import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { CoilSymbol } from '../primitives/CoilSymbol';
import { DT } from '../tokens';

/** Q = 1.08·CFM·ΔT — duct, coil, T1 (warm) → T2 (cool) gauges, color-tinted streams. */
export function DiagramQBtuh() {
  const dy = 100, dh = 70;
  const cy = dy + dh / 2;

  return (
    <DiagramCanvas>
      {/* Entering (warm) duct */}
      <Rect x={20} y={dy} width={70} height={dh} fill="rgba(255,107,26,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={28} y1={cy} x2={84} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`86,${cy} 80,${cy - 4} 80,${cy + 4}`} fill={DT.arrow} />

      {/* Coil */}
      <CoilSymbol x={90} y={dy} width={150} height={dh} loops={5} />

      {/* Leaving (cool) duct */}
      <Rect x={240} y={dy} width={80} height={dh} fill="rgba(122,170,187,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={248} y1={cy} x2={310} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`312,${cy} 306,${cy - 4} 306,${cy + 4}`} fill={DT.arrow} />

      {/* T1 thermometer (warm) */}
      <Line x1={55} y1={dy} x2={55} y2={dy - 18} stroke={DT.leader} strokeWidth="1.2" />
      <Circle cx={55} cy={dy - 30} r={11} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={55} y1={dy - 30} x2={62} y2={dy - 36} stroke="#FF6B1A" strokeWidth="1.6" />
      <Circle cx={55} cy={dy - 30} r={1.5} fill="#FF6B1A" />
      <SvgText x={55} y={dy - 44} fill="#FF6B1A" fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">T₁</SvgText>

      {/* T2 thermometer (cool) */}
      <Line x1={280} y1={dy} x2={280} y2={dy - 18} stroke={DT.leader} strokeWidth="1.2" />
      <Circle cx={280} cy={dy - 30} r={11} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={280} y1={dy - 30} x2={273} y2={dy - 26} stroke="#7AAABB" strokeWidth="1.6" />
      <Circle cx={280} cy={dy - 30} r={1.5} fill="#7AAABB" />
      <SvgText x={280} y={dy - 44} fill="#7AAABB" fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">T₂</SvgText>

      {/* ΔT brace above coil */}
      <Line x1={55} y1={dy - 56} x2={280} y2={dy - 56} stroke={DT.varColor} strokeWidth="1" />
      <Polygon points={`55,${dy - 56} 61,${dy - 53} 61,${dy - 59}`} fill={DT.varColor} />
      <Polygon points={`280,${dy - 56} 274,${dy - 53} 274,${dy - 59}`} fill={DT.varColor} />
      <SvgText x={167} y={dy - 60} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">ΔT</SvgText>

      {/* Labels */}
      <LeaderLine x1={55} y1={cy} x2={20} y2={210} varName="CFM" desc="Airflow" anchor="start" />
      <LeaderLine x1={167} y1={dy + dh - 8} x2={150} y2={210} varName="Q" desc="BTU/h" anchor="middle" />
      <LeaderLine x1={280} y1={cy} x2={310} y2={210} varName="ΔT" desc="T₁ − T₂" anchor="end" />

      <FormulaTag formula="Q = 1.08 · CFM · ΔT   (sensible)" />
    </DiagramCanvas>
  );
}
